import React, { useState, useEffect } from "react";
import { C, fBody, fOutfit } from "../../../Shared/Brand";
import { PageHeader, StatRow, StatCard, TabBar, TableWrap, EmptyState } from "../../../Shared/DashboardUI";

const CountdownTimer = ({ targetDate }) => {
   const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      let timeLeft = {};

      if (difference > 0) {
         timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            min: Math.floor((difference / 1000 / 60) % 60),
            sec: Math.floor((difference / 1000) % 60),
         };
      }

      return timeLeft;
   };

   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

   useEffect(() => {
      const timer = setInterval(() => {
         setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [targetDate]);

   const entries = Object.keys(timeLeft).filter((interval) => timeLeft[interval] !== undefined);

   if (entries.length === 0) return <span style={{ color: C.ltx2 }}>Time's up!</span>;

   return (
      <div style={{ display: 'flex', gap: '14px', marginTop: '10px' }}>
         {entries.map((interval) => (
            <div key={interval} style={{ textAlign: 'center' }}>
               <div style={{ color: C.primary, fontSize: '20px', fontWeight: 700, fontFamily: fOutfit }}>{timeLeft[interval]}</div>
               <div style={{ color: C.ltx3, fontSize: '11px' }}>{interval}</div>
            </div>
         ))}
      </div>
   );
};

function AirDrop() {
   const targetDate = "2025-12-31T23:59:59";
   const [activeTab, setActiveTab] = useState('received');
   return (
      <>
         <PageHeader title="Airdrop" />

         <div className="xdb-card" style={{ marginBottom: '16px', background: `linear-gradient(135deg, rgba(247,147,26,0.12), ${C.card})` }}>
            <div style={{ fontSize: '18px', fontWeight: 700, color: C.ltx, fontFamily: fOutfit }}>Airdrop Earning Program Started!</div>
            <p style={{ color: C.ltx2, marginBottom: '4px' }}>Invite your friends & get instant rewards</p>
            <CountdownTimer targetDate={targetDate} />
            <div style={{ background: 'rgba(62,159,247,0.1)', border: '1px solid rgba(62,159,247,0.25)', borderRadius: '10px', padding: '10px 14px', marginTop: '16px', color: C.ltx2, fontSize: '13px' }}>
               🏅 Level 1 → $5 | Level 2 → $3 | Level 3 → $1
            </div>
         </div>

         <StatRow>
            <StatCard label="Available Airdrop" value="$0.00" icon="ri-gift-line" />
            <StatCard label="Used Airdrop" value="$0.00" icon="ri-shopping-bag-line" />
            <StatCard label="Total Received Airdrop" value="$0.00" icon="ri-inbox-archive-line" />
         </StatRow>

         <div className="xdb-card">
            <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody }}>Air Drop</h5>
            <TabBar
               tabs={[{ key: 'received', label: 'Received Airdrop' }, { key: 'used', label: 'Used Airdrop' }]}
               active={activeTab}
               onChange={setActiveTab}
            />
            {activeTab === 'received' && (
               <TableWrap>
                  <thead>
                     <tr><th>#</th><th>Date</th><th>Referral</th><th>ID</th><th>Level</th><th>Amount</th></tr>
                  </thead>
                  <tbody>
                     <tr><td colSpan="6"><EmptyState /></td></tr>
                  </tbody>
               </TableWrap>
            )}
            {activeTab === 'used' && (
               <TableWrap>
                  <thead>
                     <tr><th>Sr No.</th><th>Date/Time</th><th>Amount</th><th>Tier</th><th>Income Type</th><th>Email</th><th>Invoice ID</th></tr>
                  </thead>
                  <tbody>
                     <tr><td colSpan="7"><EmptyState message="No records" /></td></tr>
                  </tbody>
               </TableWrap>
            )}
         </div>
      </>
   )
}

export default AirDrop
